export let BASE_URL = '';
if (process.env.NODE_ENV === 'production') {
    const parsedData = window.location.pathname.split('/');
    BASE_URL = parsedData[1];
}
